import * as React from "react";
import type { SVGProps } from "react";

const FacilityGasStation = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.41406 5.83301H10.4141V9.16634H5.41406V5.83301Z"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.25 12.4997H9.58333"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.91406 17.5V4.16667C2.91406 3.24583 3.6599 2.5 4.58073 2.5H11.2474C12.1682 2.5 12.9141 3.24583 12.9141 4.16667V17.5"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.2474 4.16699L17.4257 5.34533C17.7382 5.65783 17.9141 6.08199 17.9141 6.52366V14.5837C17.9141 15.2737 17.3541 15.8337 16.6641 15.8337V15.8337C15.9741 15.8337 15.4141 15.2737 15.4141 14.5837V13.3337C15.4141 12.8737 15.0407 12.5003 14.5807 12.5003H12.9141"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.9165 10.0003H16.3606C15.8598 10.0003 15.4715 9.56116 15.534 9.06366L15.7423 7.39699C15.794 6.98033 16.1481 6.66699 16.569 6.66699H17.9165"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.08203 17.4997H13.7487"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
FacilityGasStation.displayName = "FacilityGasStation";

export default FacilityGasStation;
